<script>
import Pdf from "@/CommonDP/components/PdfStamp/pdf.vue";

export default {
  extends: Pdf,
  methods: {
    cache2Stamp({
      imageFileId,
      imageHeight,
      imageWidth,
      locationX,
      locationY
    }) {
      const { width, height } = this;
      return {
        stampId: imageFileId,
        width: imageWidth * width,
        // 为了兼容服务端的处理, 服务端的坐标是左下为原点
        left: locationX * width,
        top: locationY * height - imageHeight * height
      };
    },
    stamp2data(
      { stampId: imageFileId, top, left, width, height },
      pageIndex = 1
    ) {
      const { sizes } = this;
      const { width: size_w, height: size_h } = sizes[pageIndex];
      const imageWidth = width / size_w;
      const imageHeight = height / size_h;
      // 为了兼容服务端的处理, 服务端的坐标是左下为原点
      const locationX = left / size_w;
      const locationY = (top + height) / size_h;
      return {
        imageFileId,
        locationX,
        locationY,
        imageHeight,
        imageWidth,
        pageIndex
      };
    },
    dragStart(...arg) {
      const id = arg[0].id;
      const isUsed = this.pageStamps.some(({ stampId }) => stampId === id);
      if (isUsed) {
        this.$message.error('该签章在本页已使用');
      } else {
        Pdf.methods.dragStart.apply(this, arg);
      }
    }
  }
};
</script>
